import { useState, type FormEvent } from 'react'
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../features/auth/AuthProvider'
import { useTerminalConfig } from '../App'
import { LoadingIndicator } from '../shared/ui/LoadingIndicator'

export function LoginPage() {
  const config = useTerminalConfig()
  const { session, login } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const notice = (location.state as { message?: string } | null)?.message || ''
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [passwordVisible, setPasswordVisible] = useState(false)
  const [legalAgreed, setLegalAgreed] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  if (session) return <Navigate to="/chat" replace />
  async function submit(event: FormEvent) {
    event.preventDefault(); setError('')
    if (!username.trim() || !password) { setError('请输入账号和密码'); return }
    if (!legalAgreed) { setError('请先阅读并同意用户服务协议和隐私政策'); return }
    setLoading(true)
    try { await login(username.trim(), password); const target = (location.state as { from?: string } | null)?.from || '/chat'; navigate(target, { replace: true }) } catch (reason) { setError(reason instanceof Error ? reason.message : '登录失败') } finally { setLoading(false) }
  }
  return <main className="auth-shell">
    <section className="auth-content">
      <h1 className="sr-only">登录{config.brandName}</h1>
      <header className="auth-heading"><strong>{config.brandName}</strong><span className="auth-slogan">{config.slogan}</span></header>
      <form className="auth-form" onSubmit={submit}>
        <label className="auth-input-shell"><img src="/icons/login-email.svg" alt="" /><span className="sr-only">用户名</span><input value={username} onChange={(event) => setUsername(event.target.value)} autoComplete="username" placeholder="用户名" /></label>
        <label className="auth-input-shell"><img src="/icons/login-key.svg" alt="" /><span className="sr-only">密码</span><input type={passwordVisible ? 'text' : 'password'} value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="current-password" placeholder="密码" /><button className="password-visibility" type="button" aria-label={passwordVisible ? '隐藏密码' : '显示密码'} aria-pressed={passwordVisible} onClick={() => setPasswordVisible((visible) => !visible)}><img src="/icons/login-show.svg" alt="" /></button></label>
        {notice && <p className="form-message" role="status">{notice}</p>}
        {error && <p className="form-error" role="alert">{error}</p>}
        <button className="login-button" type="submit" disabled={loading}>{loading ? <LoadingIndicator compact label="登录中…" /> : '账号密码登录'}</button>
        <p className="auth-switch"><Link to="/forgot-password">忘记密码？</Link><span> · </span><span>还没有账号？</span><Link to="/register">使用邮箱注册</Link></p>
        <label className="login-legal"><input type="checkbox" checked={legalAgreed} onChange={(event) => setLegalAgreed(event.target.checked)} /><span>我已阅读并同意 <strong>用户服务协议</strong> 和 <strong>隐私政策</strong></span></label>
      </form>
    </section>
  </main>
}
